<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <b-col cols="12" md="5" class="d-flex align-items-center justify-content-start mb-1 mb-md-0"> </b-col>
          <b-col cols="12" md="7">
            <div class="d-flex align-items-center justify-content-end">
              <b-button variant="primary" @click="addDepartment()">
                <span class="text-nowrap">Add Department</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-table :outlined="true" :fields="fields" responsive="sm" class="table table-sm" :items="filteredDepartments">
          <template #cell(title)="data">
            <div class="p-25">
              {{ data.value }}
            </div>
          </template>

          <template #cell(actions)="data">
            <div>
              <b-button variant="primary" class="mr-25 p-50" @click="editDepartment(data.item.id)">
                <i class="fa-solid fa-pen-to-square mr-25"></i>
                <span> Edit</span>
              </b-button>

              <b-button variant="primary" @click="deleteDepartment(data.item.id)" class="p-50">
                <i class="fa-solid fa-trash mr-25"></i>
                <span> Delete</span>
              </b-button>
            </div>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { BOverlay, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BFormRating } from 'bootstrap-vue';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { onUnmounted } from '@vue/composition-api';
import settingsStoreModule from '../settingsStoreModule';
import vSelect from 'vue-select';

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    vSelect,
    ToastificationContent,
  },

  setup() {
    const TASK_APP_STORE_MODULE_NAME = 'settings';
    // Register module
    if (!store.hasModule(TASK_APP_STORE_MODULE_NAME)) store.registerModule(TASK_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TASK_APP_STORE_MODULE_NAME)) store.unregisterModule(TASK_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      departments: [],
      filter: null,
      loading: true,
      fields: [
        { key: 'title', label: 'Department', sortable: true, class: 'text-left', thStyle: 'width:80%' },
        // { key: 'color', sortable: true, class: 'text-center', thStyle: 'width:20%' },
        { key: 'actions', sortable: false, class: 'text-right', thStyle: 'width:20%' },
      ],
      tempName: null,
      showAllAdditionals: false,
    };
  },

  watch: {},

  methods: {
    getDepartments() {
      this.loading = true;
      store
        .dispatch('settings/getAllDepartments')
        .then((res) => {
          this.departments = res.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push({ name: 'settings' });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'An error occurred',
              text: 'Please try again later or contact support.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        });
    },

    editDepartment(id) {
      this.$router.push({ name: 'settings-department-edit', params: { id: id } });
    },

    deleteDepartment(id) {
      this.$bvModal
        .msgBoxConfirm('Are you sure you want to delete this department?', {
          size: 'sm',
          title: 'Confirm Deletion',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true;
            const department = this.departments.find((met) => met.id === id);

            if (department) {
              store
                .dispatch('settings/deleteDepartment', department)
                .then((response) => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Successful',
                      text: '✔️ Department Delete Successful',
                      icon: 'ThumbsUpIcon',
                      variant: 'success',
                    },
                  });

                  this.getDepartments();
                })
                .catch((error) => {
                  this.formShow = false;
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'An error occurred',
                      text: 'Please try again later or contact support.',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  });
                });
            }
          }
        });
    },

    addDepartment() {
      this.$router.push({ name: 'settings-department-add' });
    },
  },

  created() {
    this.getDepartments();
  },

  computed: {
    filteredDepartments() {
      if (!this.filter) {
        return this.departments;
      } else {
        this.departments = this.departments.filter((met) => met.id !== undefined);

        this.departments.forEach((met) => {
          met.editable = false;
        });

        const searchTerm = this.filter.toLowerCase();
        return this.departments.filter((met) => met.code.toLowerCase().includes(searchTerm));
      }
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
